/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterPathwayDto } from '../../models/filter-pathway-dto';
import { ResponsePathwayDto } from '../../models/response-pathway-dto';

export interface PathwaysControllerFilter$Params {
  
    /**
     * The filter criteria for pathways
     */
    body: FilterPathwayDto
}

export function pathwaysControllerFilter(http: HttpClient, rootUrl: string, params: PathwaysControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePathwayDto>>> {
  const rb = new RequestBuilder(rootUrl, pathwaysControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponsePathwayDto>>;
    })
  );
}

pathwaysControllerFilter.PATH = '/thalea-pathways/pathways/filter';
